import { useState } from 'react';
import { useShallow } from 'zustand/react/shallow';
import LeftPanelContainer from '../features/left-panel/LeftPanelContainer';
import MapView from '../features/map/components/MapView';
import { Header } from '../common/Header';
import { Footer } from '../common/Footer';
import MainLayout from '../layouts/MainLayout';
import RightPanelContainer from '../features/right-panel/RightPanelContainer';
import LoadingOverlay from '../common/LoadingOverlay/LoadingOverlay';
import useGeoData from '../store/useGeoData';

function App() {
  // Local state for charts display visibility
  const [isChartsDisplayVisible, setIsChartsDisplayVisible] = useState(false);

  // Get print generation state from Zustand
  const { isGenerating } = useGeoData(useShallow((state) => ({
    isGenerating: state.isGenerating,
  })));

  const handleToggleChartsDisplay = () => {
    setIsChartsDisplayVisible(!isChartsDisplayVisible);
  };

  return (
    <div className="app-container"> {/* Potrebbe essere utile un contenitore generale */}
      <Header />
      <MainLayout
        panelLeft={<LeftPanelContainer />}
        mapCenter={<MapView />}
        panelRight={<RightPanelContainer 
          isChartsDisplayVisible={isChartsDisplayVisible}
          onToggleChartsDisplay={handleToggleChartsDisplay}
        />} // Passa sempre il contenitore
      />
      <Footer />
      <LoadingOverlay 
        isVisible={isGenerating} 
      />
    </div>
  )
}

export default App